const initialState = {
  loading: false,
  data: null,
  error: null,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USERS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_USERS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_USERS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_USER":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          profile_img: action.payload.profile_img,
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          email: action.payload.email,
          phone_number: action.payload.phone_number,
        },
      };
    default:
      return state;
  }
};

export default usersReducer;
